import ApplicationHelper from 'helpers/application_helper'
import Settings from 'helpers/settings'
import AuthHelper from 'helpers/auth_helper'
import SCPusher from 'classes/sc_pusher'
import SCTrack from 'classes/sc_track'
import SCLocalStorage from 'classes/sc_localstorage'
import { fetchUnreadConversationsCount } from 'store/actions'
import store from 'store/configureStore'
import QueryHelpers from 'helpers/query_helpers'
import WebNotificationHelper from 'helpers/web_notification_helpers'
import { putV2 } from 'api'

const $ = window.jQuery
const jQuery = $

const LocalStorage = new SCLocalStorage()
const InitHelper = {
  authInit() {
    AuthHelper.loadFromBackend()
      .then(() => {
        if (AuthHelper.logged_in) {
          store.store.dispatch(fetchUnreadConversationsCount())
          SCPusher.bindProfileUpdate()
          SCPusher.bindNotifications()
          SCPusher.bindUnreadConversations()
        }
      })
      .catch(() => {})
  },

  async webPushInit(shouldRequestPermission = false) {
    if (!AuthHelper.logged_in) return false

    let permission = Notification.permission,
      hasPermission = WebNotificationHelper.hasPermission(),
      canAskPermission = WebNotificationHelper.canAskPermission()

    // Eventually we should ask for permission only during user gesture
    if (!hasPermission && shouldRequestPermission && canAskPermission) {
      permission = await WebNotificationHelper.requestPushPermission()
      hasPermission = WebNotificationHelper.hasPermission()
    }

    console.log('Web Push Notifications ' + permission)
    if (!hasPermission) return

    let subscription = await WebNotificationHelper.getPushSubscriptionObject()
    if (!subscription) {
      await WebNotificationHelper.subscribePush()
      subscription = await WebNotificationHelper.getPushSubscriptionObject()
    }

    // Still can be null after switching permissions on for the first time
    if (subscription) {
      // We should probably check this less often, but for now
      await putV2('/v2/web_push/subscriptions', { body: { subscription } })
    }
  },

  ajaxInit() {
    $.ajaxSetup({
      // Add the correct service token at the beggining and append
      // the auth_token at the end
      beforeSend: (xhr, options) => {
        /**
         * If the URL has a protocol already, we don't do anything.
         * Example use cases: Cloudinary API calls
         */
        if (!options.url.startsWith('http')) {
          const url = Settings.SWIPECAST_BACKEND + options.url
          xhr.setRequestHeader('Authorization', `Bearer ${AuthHelper.currentAuthToken()}`)
          // eslint-disable-next-line
          options.url = url
        }
      },
    })
  },

  trackingInit() {
    SCTrack.init()
  },

  resizeInit() {
    jQuery(document).ready(($) => {
      $(window).on('resize', () => {
        ApplicationHelper.detectResize()
      })
    })

    ApplicationHelper.detectResize()
  },

  setSearchParamsToStorage() {
    const referralCode = QueryHelpers.getParam(QueryHelpers.keys.referralCode)
    const utm = QueryHelpers.getUTM()
    LocalStorage.setReferrer()
    if (referralCode) LocalStorage.setReferralCode(referralCode)
    if (Object.values(utm).length) LocalStorage.setUTM(utm)
  },
}

export default InitHelper
